import { AdjustmentIdentifier, FilterCategoryIdentifier, FilterIdentifier, FocusIdentifier, Tool, TransformIdentifier } from '@assets/vendor/photoeditorsdk';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export const PHOTO_EDITOR_5_CONFIG = {
    smpConfigBuilderParams: {
        stickerPaths: {
            category: "../../assets_smp/categories/",
            base: "../../assets_smp/stickers/base/",
            thumb: "../../assets_smp/stickers/thumb/",
        },
        colors: [
            { name: "yellow", color: [255/255.0, 255/255.0, 0, 1.0] },
            { name: "red", color: [255/255.0, 0, 0, 1.0] },
            { name: "white", color: [255/255.0, 255/255.0, 255/255.0, 1.0] },
            { name: "black", color: [0, 0, 0, 1.0] }
        ],
        stickerColors: [
            { name: "yellow", categoryName: marker("photo_editor.controls.stickers.categories.forms-yellow") },
            { name: "red", categoryName: marker("photo_editor.controls.stickers.categories.forms-red") },
            { name: "white", categoryName: marker("photo_editor.controls.stickers.categories.forms-white") },
            { name: "black", categoryName: marker("photo_editor.controls.stickers.categories.forms-black") }
        ],
        customStickers: [
            {
                identifier: "rectangle-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted",
            },
            {
                identifier: "rectangle-border-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted"
            },
            {
                identifier: "circle-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted"
            },
            {
                identifier: "circle-border-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted"
            },
            {
                identifier: "line-COLOR_PLACEHOLDER-h",
                resizeMode: "unrestricted"
            },
            {
                identifier: "line-COLOR_PLACEHOLDER-v",
                resizeMode: "unrestricted"
            },
            {
                identifier: "arrow-COLOR_PLACEHOLDER",
                resizeMode: "keepAspect"
            },
            {
                identifier: "triangle-border-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted"
            },
            {
                identifier: "elipses-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted"
            },
            {
                identifier: "elipses-border-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted"
            },
            {
                identifier: "square-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted"
            },
            {
                identifier: "square-border-COLOR_PLACEHOLDER",
                resizeMode: "unrestricted"
            }
        ]
    },
    assetBaseUrl: "/assets/vendor/photoeditorsdk/assets",
    tools: [ Tool.TRANSFORM, Tool.FILTER, Tool.ADJUSTMENT, Tool.FOCUS, Tool.TEXT, Tool.STICKER, Tool.BRUSH ],
    transform: {
        categories: [{
            identifier: "imgly_transforms_common",
            items: [
                { identifier: TransformIdentifier.Custom },
                { identifier: TransformIdentifier.Square },
                { identifier: TransformIdentifier.FourByThree },
                { identifier: TransformIdentifier.SixteenByNine }
            ]
        }]
    },
    filter: {
        enablePreviewThumbnails: true,
        categories: [
            {
                identifier: FilterCategoryIdentifier.DuoTone,
                items: [
                    { identifier: FilterIdentifier.Desert },
                    { identifier: FilterIdentifier.Peach },
                    { identifier: FilterIdentifier.Clash },
                    { identifier: FilterIdentifier.Plum },
                    { identifier: FilterIdentifier.Breezy },
                    { identifier: FilterIdentifier.DeepBlue },
                    { identifier: FilterIdentifier.Frog },
                    { identifier: FilterIdentifier.Sunset }
                ],
            },
            {
                identifier: FilterCategoryIdentifier.BW,
                items: [
                    { identifier: FilterIdentifier.AD1920 },
                    { identifier: FilterIdentifier.Greyed },
                    { identifier: FilterIdentifier.Dusty },
                    { identifier: FilterIdentifier.Litho },
                    { identifier: FilterIdentifier.Sepia },
                    { identifier: FilterIdentifier.Weathered },
                    { identifier: FilterIdentifier.HardStuff }
                ],
            },
            {
                identifier: FilterCategoryIdentifier.Vintage,
                items: [
                    { identifier: FilterIdentifier.Polaroid },
                    { identifier: FilterIdentifier.Sunny70s },
                    { identifier: FilterIdentifier.Oldtimer },
                    { identifier: FilterIdentifier.Inferno },
                    { identifier: FilterIdentifier.Snappy }
                ],
            },
            {
                identifier: FilterCategoryIdentifier.Smooth,
                items: [
                    { identifier: FilterIdentifier.Chestnut },
                    { identifier: FilterIdentifier.Softy },
                    { identifier: FilterIdentifier.Pebble },
                    { identifier: FilterIdentifier.Moss },
                    { identifier: FilterIdentifier.Lemon },
                    { identifier: FilterIdentifier.GreenGap },
                ],
            },
            {
                identifier: FilterCategoryIdentifier.Cold,
                items: [
                    { identifier: FilterIdentifier.Colla },
                    { identifier: FilterIdentifier.Solanus },
                    { identifier: FilterIdentifier.Kalmen },
                    { identifier: FilterIdentifier.Joran },
                    { identifier: FilterIdentifier.Levante },
                    { identifier: FilterIdentifier.Zephyr },
                ],
            },
            {
                identifier: FilterCategoryIdentifier.Warm,
                items: [
                    { identifier: FilterIdentifier.Golden },
                    { identifier: FilterIdentifier.LowFire },
                    { identifier: FilterIdentifier.Sunrise },
                    { identifier: FilterIdentifier.FlatBlack },
                    { identifier: FilterIdentifier.Pumpkin },
                ],
            },
            {
                identifier: FilterCategoryIdentifier.Legacy,
                items: [
                    { identifier: FilterIdentifier.Ancient },
                    { identifier: FilterIdentifier.Candy },
                    { identifier: FilterIdentifier.Classic },
                    { identifier: FilterIdentifier.Colorful },
                    { identifier: FilterIdentifier.Creamy },
                    { identifier: FilterIdentifier.Fixie },
                    { identifier: FilterIdentifier.Food },
                    { identifier: FilterIdentifier.Fridge },
                    { identifier: FilterIdentifier.Glam },
                    { identifier: FilterIdentifier.Gobblin },
                    { identifier: FilterIdentifier.Hicon },
                    { identifier: FilterIdentifier.HighCarb },
                    { identifier: FilterIdentifier.K1 },
                    { identifier: FilterIdentifier.K6 },
                    { identifier: FilterIdentifier.Keen },
                    { identifier: FilterIdentifier.Lomo },
                    { identifier: FilterIdentifier.Lomo100 },
                    { identifier: FilterIdentifier.Lucid },
                    { identifier: FilterIdentifier.Mellow },
                    { identifier: FilterIdentifier.Neat },
                    { identifier: FilterIdentifier.Pale },
                    { identifier: FilterIdentifier.Pitched },
                    { identifier: FilterIdentifier.PolaSX },
                    { identifier: FilterIdentifier.Pro400 },
                    { identifier: FilterIdentifier.Quozi },
                    { identifier: FilterIdentifier.Settled },
                    { identifier: FilterIdentifier.Seventies },
                    { identifier: FilterIdentifier.Soft },
                    { identifier: FilterIdentifier.Steel },
                    { identifier: FilterIdentifier.Summer },
                    { identifier: FilterIdentifier.Tender },
                    { identifier: FilterIdentifier.Twilight }
                ]
            }
        ]
    },
    adjustment: {
        categories: [{
            identifier: 'basics',
            items: [
                { identifier: AdjustmentIdentifier.BRIGHTNESS },
                { identifier: AdjustmentIdentifier.SATURATION },
                { identifier: AdjustmentIdentifier.CONTRAST },
                { identifier: AdjustmentIdentifier.GAMMA }
            ]
        }, {
            identifier: 'refinements',
            items: [
                { identifier: AdjustmentIdentifier.CLARITY },
                { identifier: AdjustmentIdentifier.EXPOSURE },
                { identifier: AdjustmentIdentifier.SHADOWS },
                { identifier: AdjustmentIdentifier.HIGHLIGHTS }
            ]
        }],
        flattenCategories: false
    },
    focus: {
        items: [
            { identifier: FocusIdentifier.RADIAL },
            { identifier: FocusIdentifier.MIRRORED },
            { identifier: FocusIdentifier.LINEAR },
            { identifier: FocusIdentifier.GAUSSIAN }
        ]
    },
    text: {
        backgroundColors: [], // Will be filled by PhotoEditorConfigService
        colors: [] // Will be filled by PhotoEditorConfigService
    },
    sticker: {
        categories: [] // Will be filled by PhotoEditorConfigService
    },
    brush: {
        colors: [] // Will be filled by PhotoEditorConfigService
    }
};
